@import 'styles/mixins';
@import 'styles/variables';
@import 'styles/blaze/mixins';

.bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  padding: 18px 20px 20px;
  box-sizing: border-box;
  animation: slideUp 0.2s ease;
  pointer-events: none;
}

.navButton {
  align-items: center;
  border-radius: 99px;
  border: 1px solid #fff;
  pointer-events: auto;
  background: rgba(0, 0, 0, 0.5);
  box-shadow: 0 1px 56px 0 rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);
  color: var(--light-100);
  display: inline-flex;
  height: 48px;
  justify-content: center;
  padding: 14px;
  white-space: nowrap;

  &.disabled:hover {
    cursor: default;
  }

  &.left {
    margin-right: 8px;
  }

  &.right {
    margin-left: 8px;
  }

  .textContainer {
    align-items: center;
    display: flex;
    gap: 6px;
    padding: 0 10px;
  }
}

.spacer {
  flex-grow: 1;
}

.generating {
  background: var(--light-100);
}

.finished {
  background: var(--dark-90);
}

.barContent {
  display: flex;
  align-items: center;
  border-radius: 99px;
  border-top: 1px solid var(--dark-8);
  background: var(--light-100);
  gap: 12px;
  padding: 13px 16px;
  width: 100%;
  pointer-events: auto;
}

.statusSection {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  @include sm-sohne;
}

.spinnerWrap {
  display: flex;
  align-items: center;
  padding-right: 10px;
  flex-shrink: 0;
}

.spinnerImg {
  width: 20px;
  height: 20px;
  animation: spinRotate 1.2s linear infinite;
}

@keyframes spinRotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.rightSection {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-shrink: 0;
  @include sm-sohne;
}

.statusLabelWrapper {
  display: flex;
  align-items: baseline;
  white-space: nowrap;
  overflow: hidden;
  min-width: 0;
}

.statusLabel {
  background: linear-gradient(90deg, var(--dark-90) 0%, var(--dark-20) 20%, var(--dark-90) 38%);
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: shimmerText 2s ease-in-out infinite;
  flex-shrink: 0;
}

@keyframes shimmerText {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

.counters {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  white-space: nowrap;
}

.countText {
  color: var(--dark-60);
}

.timerText {
  color: var(--dark-60);
  font-variant-numeric: tabular-nums;
  min-width: 4ch;
  text-align: right;
}

.finishedText {
  @include sm-sohne;
  color: var(--light-90);
  white-space: nowrap;
}

.finishedContent {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  pointer-events: auto;
}

.actionButton {
  @include sm-sohne;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 3px 8px;
  background: var(--light-100);
  border: 1px solid var(--dark-8);
  border-radius: 6px;
  color: var(--dark-90);
  cursor: pointer;
  flex-shrink: 0;
  white-space: nowrap;
  @include transition;

  &:hover {
    background: var(--dark-3);
  }
}

.finishedActionButton {
  &:hover {
    background: var(--light-100);
    opacity: 0.9;
  }
}

.animatedDots {
  display: inline-block;
  flex-shrink: 0;
  min-width: 1.5ch;
  color: var(--dark-90);
  -webkit-text-fill-color: var(--dark-90);

  &::after {
    content: '';
    animation: dotsSequence 1.6s steps(1) infinite;
  }
}

@keyframes dotsSequence {
  0% {
    content: '';
  }
  25% {
    content: '.';
  }
  50% {
    content: '..';
  }
  75% {
    content: '...';
  }
}

.contentOverlay {
  position: absolute;
  top: $top-bar-height;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 99;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease 0.1s;
}

.contentOverlayVisible {
  opacity: 1;
  pointer-events: auto;
}

.barWithPanel {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  height: 66%;
  min-height: 450px;
  max-height: 80vh;
  transform: translateY(0);
  transition: transform 0.3s ease;
  overflow: hidden;
  animation: panelSlideIn 0.3s ease;

  &.minimized {
    transform: translateY(calc(100% - #{$generation-bar-height}));
  }

  .bar {
    position: relative;
    animation: none;
    flex-shrink: 0;
    box-shadow: none;
  }
}

@keyframes panelSlideIn {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.minimizeButton {
  @include sm-sohne;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px 8px;
  pointer-events: auto;
  background: var(--light-100);
  border: 1px solid var(--dark-8);
  border-radius: 6px;
  color: var(--dark-90);
  cursor: pointer;
  flex-shrink: 0;
  white-space: nowrap;
  @include transition;

  &:hover {
    background: var(--dark-3);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
